module.exports = new __parcel__URL__("bigPicture.bdf23130.png").toString();